import React from "react";

export default function FullPageLoadingModal({ message = "Loading..." }) {
  return (
    <div className="tw-fixed tw-inset-0 tw-flex tw-items-center tw-justify-center tw-bg-white/90 dark:tw-bg-slate-900/80 tw-z-[2000]">
    <div className="tw-flex tw-flex-col tw-items-center tw-gap-4 tw-bg-white tw-p-8 tw-rounded-3xl tw-shadow-2xl tw-border tw-border-gray-100 dark:tw-bg-slate-900 dark:tw-border-neutral-800">
      <div className="tw-h-14 tw-w-14 tw-rounded-full tw-border-4 tw-border-blue-500 tw-border-t-transparent tw-animate-spin dark:tw-border-sky-400 dark:tw-border-t-transparent" />
        <p className="tw-text-sm tw-font-semibold tw-text-gray-700 dark:tw-text-gray-100">
          {message}
        </p>
      </div>
    </div>
  );
}
